/**
 * React Native-friendly mock for react-native-screens
 */

import React, { forwardRef } from 'react';
import { View } from 'react-native';

const RNView = forwardRef(({ children, style, ...props }, ref) => (
  <View ref={ref} style={[{ flex: 1 }, style]} {...props}>
    {children}
  </View>
));

export const Screen = RNView;
export const ScreenContainer = RNView;
export const ScreenStack = RNView;
export const NativeScreen = RNView;
export const NativeScreenContainer = RNView;

export const enableScreens = () => {};
export const screensEnabled = () => false;

export default {
  Screen,
  ScreenContainer,
  ScreenStack,
  NativeScreen,
  NativeScreenContainer,
  enableScreens,
  screensEnabled,
};
